import React from 'react';
import classNames from 'classnames';

import { UnderlinedHeaderProps } from './UnderlinedHeaderProps';

import * as styles from './UnderlinedHeader.module.scss';

export const UnderlinedHeader: React.FC<UnderlinedHeaderProps> = ({
	children,
	className,
	subtitle,
	subtitleClassName,
	dividerStyles,
}) => {
	return (
		<div className={classNames(styles.root, className)}>
			<h1 className="font-size-large">{children}</h1>
			<hr style={dividerStyles} className={styles.divider} />
			<p className={classNames(subtitleClassName, 'font-size-md')}>
				{subtitle}
			</p>
		</div>
	);
};
